import { FC } from "react";
import { GradientButton, PhoneFrame } from "./components";
import { useLocation, useNavigate } from "react-router-dom";

import IdentificationSVG from "../../assets/IdentificationSVG.svg";
import "./styles.css";

export const Identification: FC = () => {
	const location = useLocation();

	const { accountType } = location.state;

	const navigate = useNavigate();

	return (
		<div className="w-full h-screen flex justify-center items-center gap-20 background max-2xl:gap-5">
			<PhoneFrame
				onPress={() =>
					navigate("/create-account-wallet/adding-secure", {
						state: { accountType },
					})
				}
			/>

			<div className="bg-[#7C7775]/80 h-[95vh] max-w-[50%] rounded-2xl p-[4%] flex flex-col items-center justify-center border-2 border-black">
				<div className="w-full flex flex-col items-center justify-center">
					<h1 className="text-white text-3xl font-bold mb-7 max-2xl:text-xl max-2xl:mb-3">
						Identifique-se
					</h1>
					<p className="text-white text-lg text-center font-extralight mb-7 max-2xl:mb-3 max-2xl:text-base">
						Hora da selfie, o ambiente deve está bem <br />
						iluminado de forma moderada. Dê <br />
						preferência á iluminação natural, centralize <br />o rosto e evite
						sombras em seu rosto.
					</p>
					<img
						className="mb-4 w-[60%] h-[70%] max-2xl:w-[45%] max-2xl:h-[45%]"
						src={IdentificationSVG}
						alt=""
					/>

					<div className="flex gap-4">
						<GradientButton
							title="Voltar"
							tailwindStyles="bg-[#171717] w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/adding-secure", {
									state: { accountType },
								})
							}
						/>
						<GradientButton
							title="Avançar"
							tailwindStyles="bg-[#AA7339] w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/send-identification-photo", {
									state: { accountType },
								})
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
